import { Breadcrumbs as BreadcrumbsMui, Typography } from '@mui/material';
import * as React from 'react';
import { Link, useLocation } from 'react-router';
import { IBreadcrumbs } from './interfaces';

export const Breadcrumbs: React.FC<IBreadcrumbs> = ({
  crumbs,
  current,
}): JSX.Element => {
  const location = useLocation();

  return (
    <BreadcrumbsMui aria-label="breadcrumb">
      {crumbs.map((crumb) => {
        let to = crumb.link;
        const from = location.state?.from;

        if (from?.pathname === crumb.link && location.state?.from?.pathname) {
          to = location.state?.from?.pathname + location.state?.from?.search;
        }

        return (
          <Link
            key={crumb.link}
            to={to}
            state={{ from: location }}
            style={{
              textDecoration: 'none',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: 'text.secondary',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {crumb.title}
            </Typography>
          </Link>
        );
      })}
      <Typography sx={{ color: 'text.primary', fontWeight: 'bold' }}>
        {current}
      </Typography>
    </BreadcrumbsMui>
  );
};
